import { render, staticRenderFns } from "./AppAccordion.vue?vue&type=template&id=63c5210e&"
import script from "./AppAccordion.vue?vue&type=script&lang=js&"
export * from "./AppAccordion.vue?vue&type=script&lang=js&"
import style0 from "./AppAccordion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports